import { useEffect } from "react";
import NiceModal from "components/modals/NiceModal";
import styled from "styled-components";

import TrackingAPI from '../../api/TrackingAPI';

interface IsLegalRequestModalProps {
  onClose: () => void;
  isVisible: boolean;
}

const LegalRequestModal: React.FC<IsLegalRequestModalProps> = (props) => {
  const { onClose, isVisible } = props;



  useEffect(() => {
    if (!isVisible) return;
    const trackEvent = () => {
      const getAnalyticsDataByReasons = () => {
        return {
          rendered_for_reason: 'illegal_dialog_request',
        };
      };

      try {
        TrackingAPI.trackEvent('illegal_request_modal', getAnalyticsDataByReasons());
      } catch (error) {
        throw error;
      }
    };

    trackEvent();
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <NiceModal
      onClose={onClose}
    >
      <Root>
        <TextWrapper>
          <Text>
            I cannot fulfill this request as it appears to be illegal and unethical.
          </Text>
          <Text>
            Please keep our interaction safe and legal.
          </Text>
          <Text>
            If you continue to make inappropriate requests, your access to this service may be restricted.
          </Text>
        </TextWrapper>
        <Button onClick={onClose}>Ok</Button>
      </Root>
    </NiceModal>
  );
};

export default LegalRequestModal;


const Root = styled.div`
  width: 380px;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 32px;
  @media (max-width: 400px) {
    width: 100%;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 32px;
`;

const Text = styled.p`
  font-family: Nunito Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
`;

const Button = styled.button`
  width: 100%;
  padding: 8px 16px 8px 16px;
  border-radius: 64px;
  background: #ff7e55;
`;